<template>
    <router-view/>
</template>

<script setup>
    import { useHead } from '@/composables/common/seo/useHead';

    useHead('Perfil');
</script>